import {
  InitAppOptions,
  PluginsEditorType,
} from '@wix/editor-platform-host-integration-apis';
import { getUserInfo } from '@wix/toolbelt';
import { compact, last } from 'lodash';
import { EditorSubType } from '@wix/editor-platform-sdk-types';

interface KnownEditorQueryParams {
  metaSiteId?: string;
}

type QueryParams = KnownEditorQueryParams & {
  [K in string]?: string;
};

export const getQueryParams = (): QueryParams => {
  return Object.fromEntries(
    new URL(window.location.href).searchParams.entries(),
  );
};

export const getEditorInfo = () => {
  return window.commonConfig;
};

export const getArtifactVersion = (name: string): string | undefined =>
  last(compact(self?.serviceTopology?.scriptsLocationMap?.[name]?.split('/')));

export const getIsImpersonated = () => {
  return window?.editorModel?.isImpersonated;
};

export const getEditorSessionId = () => {
  return window?.editorModel?.editorSessionId;
};

export const shouldForceAppInstallation = () => {
  const queryParams = getQueryParams();
  return queryParams.forceAppInstallation === 'true';
};

export const getMetaSiteId = () => {
  const params = getQueryParams();
  return params.metaSiteId!;
};

export const getUserId = () => {
  return getUserInfo().id;
};

export const getHostTypeFromInitOptions = (
  options?: InitAppOptions,
): string => {
  if (options?.origin.type === 'CLASSIC') {
    return 'editor';
  }

  if (options?.origin.type === 'RESPONSIVE') {
    return 'editor_x';
  }

  return '';
};

export const getPluginsEditorType: () => PluginsEditorType = () => {
  const host = getEditorInfo()?.host;
  switch (host) {
    case 'EDITOR':
      return PluginsEditorType.Classic;
    case 'EDITOR_X':
      return PluginsEditorType.Responsive;
    case 'STUDIO':
      return PluginsEditorType.Studio;
    case 'BLOCKS':
      return PluginsEditorType.Blocks;
    case undefined:
      throw new Error('NoHostDetected');
    default:
      throw new Error(`UnknownHost: ${host}`);
  }
};

export const getEditorSubType = () => {
  const host = getEditorInfo()?.host;
  switch (host) {
    case 'EDITOR':
      return EditorSubType.Classic;
    case 'EDITOR_X':
      return EditorSubType.EditorX;
    case 'ODEDITOR':
    case 'EDITOR3':
      return EditorSubType.Editor3;
    case 'STUDIO':
      return EditorSubType.Studio;
    case 'STUDIO2':
      return EditorSubType.Studio2;
    case 'MOBILE_APP_BUILDER':
      return EditorSubType.MobileStudio;
    case 'BLOCKS':
      return EditorSubType.Blocks;
    case undefined:
      throw new Error('No host detected.');
    default:
      throw new Error('Unknown host.');
  }
};

export const stringAsCssVar = (value: string) => `var(--${value})`;

export function addIf(cond: boolean, obj: Record<string, any>) {
  return cond ? obj : {};
}
